import React from 'react';
import { FormattedMessage } from 'react-intl';
export const MemberTabs = {
    MEMBERS: 'MEMBERS',
    MODERATORS: 'MODERATORS',
};
export const tabs = [
    { value: MemberTabs.MEMBERS, label: React.createElement(FormattedMessage, { id: "tabs.members" }) },
    { value: MemberTabs.MODERATORS, label: React.createElement(FormattedMessage, { id: "tabs.moderators" }) },
];
//# sourceMappingURL=constants.js.map